import { inputTextProps, inputSelectProps } from '@/assets/props/defaultProps';
import { graduateOptionItems } from '@/assets/items/defaultItems';
import { onlyNumberRegExp } from '@/assets/commonRules';

export const education = {
  title: '1. 학력사항',
  inputs: [
    {
      inputName: 'high_school_graduate_year',
      colProps: {
        cols: 12, sm: 6, md: 2, xl: 2,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        inputProps: {
          ...inputTextProps,
          label: '고등학교 졸업년도',
          required: true,
          appendIcon: '$complete',
          rules: [
            v => !!v || '고등학교 졸업년도를 입력해 주세요.',
            v => !v || !!v.match(onlyNumberRegExp) || '고등학교 졸업년도는 숫자만 입력해 주세요.',
            v => !v || v.length === 4 || '고등학교 졸업년도는 4자리로 입력해 주세요.',
          ],
        },
      },
    },
    {
      inputName: 'high_school_name',
      colProps: {
        cols: 12, sm: 6, md: 3, xl: 3,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        inputProps: {
          ...inputTextProps,
          label: '고등학교명',
          required: true,
          appendIcon: '$complete',
          rules: [v => !!v || '고등학교명을 입력해 주세요.'],
        },
      },
    },
    {
      colProps: {
        cols: 12, sm: 6, md: 3, xl: 3,
      },
      inputInfos: {
        inputComponent: 'v-spacer',
        inputProps: {
          label: '공란',
        },
      },
    },
    {
      colProps: {
        cols: 12, sm: 6, md: 4, xl: 4,
      },
      inputInfos: {
        inputComponent: 'v-spacer',
        inputProps: {
          label: '공란',
        },
      },
    },
    {
      inputName: 'university_graduate_year',
      colProps: {
        cols: 12, sm: 6, md: 2, xl: 2,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        inputProps: {
          ...inputTextProps,
          label: '대학(교) 졸업년도',
          required: true,
          appendIcon: '$complete',
          rules: [
            v => !!v || '대학(교) 졸업년도를 입력해 주세요.',
            v => !v || !!v.match(onlyNumberRegExp) || '대학(교) 졸업년도는 숫자만 입력해 주세요.',
            v => !v || v.length === 4 || '대학(교) 졸업년도는 4자리로 입력해 주세요.',
          ],
        },
      },
    },
    {
      inputName: 'university_name',
      colProps: {
        cols: 12, sm: 6, md: 3, xl: 3,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        inputProps: {
          ...inputTextProps,
          label: '대학(교)명',
          required: true,
          appendIcon: '$complete',
          rules: [v => !!v || '대학(교)명을 입력해 주세요.'],
        },
      },
    },
    {
      inputName: 'university_major',
      colProps: {
        cols: 12, sm: 4, md: 3, xl: 3,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        inputProps: {
          ...inputTextProps,
          label: '대학(교) 전공',
          required: true,
          appendIcon: '$complete',
          rules: [v => !!v || '대학(교) 전공을 입력해 주세요.'],
        },
      },
    },
    {
      inputName: 'university_grade',
      colProps: {
        cols: 12, sm: 4, md: 2, xl: 2,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        inputProps: {
          ...inputTextProps,
          label: '대학(교) 학점(4.5/4.3 기준)',
          required: true,
          appendIcon: '$complete',
          rules: [v => !!v || '대학(교) 학점(4.5/4.3 기준)을 입력해 주세요.'],
        },
      },
    },
    {
      inputName: 'university_graduate',
      colProps: {
        cols: 12, sm: 4, md: 2, xl: 2,
      },
      inputInfos: {
        inputComponent: 'v-select',
        inputProps: {
          ...inputSelectProps,
          label: '대학(교) 졸업구분',
          items: graduateOptionItems,
          required: true,
          appendIcon: '$complete',
          rules: [v => !!v || '대학(교) 졸업구분을 선택해 주세요.'],
        },
      },
    },
    {
      inputName: 'grad_school_graduate_year',
      colProps: {
        cols: 12, sm: 6, md: 2, xl: 2,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        inputProps: {
          ...inputTextProps,
          label: '대학원 졸업년도',
          rules: [
            v => !v || !!v.match(onlyNumberRegExp) || '대학(교) 졸업년도는 숫자만 입력해 주세요.',
            v => !v || v.length === 4 || '대학(교) 졸업년도는 4자리로 입력해 주세요.',
          ],
        },
      },
    },
    {
      inputName: 'grad_school_name',
      colProps: {
        cols: 12, sm: 6, md: 3, xl: 3,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        inputProps: {
          ...inputTextProps,
          label: '대학원명',
        },
      },
    },
    {
      inputName: 'grad_school_major',
      colProps: {
        cols: 12, sm: 4, md: 3, xl: 3,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        inputProps: {
          ...inputTextProps,
          label: '대학원 전공',
        },
      },
    },
    {
      inputName: 'grad_school_grade',
      colProps: {
        cols: 12, sm: 4, md: 2, xl: 2,
      },
      inputInfos: {
        inputComponent: 'v-text-field',
        inputProps: {
          ...inputTextProps,
          label: '대학원 학점(4.5/4.3 기준)',
        },
      },
    },
    {
      inputName: 'grad_school_graduate',
      colProps: {
        cols: 12, sm: 4, md: 2, xl: 2,
      },
      inputInfos: {
        inputComponent: 'v-select',
        inputProps: {
          ...inputSelectProps,
          label: '대학원 졸업구분',
          items: graduateOptionItems,
        },
      },
    },

  ],
};